import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchPeopleLevelInBrandSuccess, fetchPeopleLevelInBrandError, updatePeopleLevelInBrandSuccess, updatePeopleLevelInBrandError } from '../actions/PeopleLevelInBrand';
import { getDocs, updateDoc } from 'firebase/services/peopleLevelInBrand';
import {FETCH_PEOPLE_LEVEL_IN_BRAND, UPDATE_PEOPLE_LEVEL_IN_BRAND} from 'constants/ActionTypes';

function* fetchPeopleLevelInBrandRequest() {
  try {
    const fetchedPeopleLevelInBrandList = yield call(getDocs);
    yield put(fetchPeopleLevelInBrandSuccess(fetchedPeopleLevelInBrandList));
  } catch (error) {
    console.log(error);
    yield put(fetchPeopleLevelInBrandError(error));
  }
}

function* updatePeopleLevelInBrandRequest({ params }) {
  try {
    const requests = params.map(param => call(updateDoc, {key: param.key, data: param}));
    const result = yield all(requests);
    yield put(updatePeopleLevelInBrandSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updatePeopleLevelInBrandError(error));
  }
}

export function* fetchPeopleLevelInBrand() {
  yield takeEvery(FETCH_PEOPLE_LEVEL_IN_BRAND, fetchPeopleLevelInBrandRequest);
}

export function* updatePeopleLevelInBrand() {
  yield takeEvery(UPDATE_PEOPLE_LEVEL_IN_BRAND, updatePeopleLevelInBrandRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchPeopleLevelInBrand), fork(updatePeopleLevelInBrand)]);
}
